import { render, staticRenderFns } from "./ItemHistory.vue?vue&type=template&id=53224118&scoped=true"
import script from "./ItemHistory.vue?vue&type=script&lang=js"
export * from "./ItemHistory.vue?vue&type=script&lang=js"
import style0 from "./ItemHistory.vue?vue&type=style&index=0&id=53224118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53224118",
  null
  
)

export default component.exports